import log from '@/logger';

function set(key, value) {
  const data = {
    value,
  };
  sessionStorage.setItem(key.toString(), JSON.stringify(data));
}

function get(key, defaultValue) {
  try {
    const data = JSON.parse(sessionStorage.getItem(key.toString()));
    if (data !== null) {
      return data.value;
    }
  } catch (error) {
    log.warn('Corrupted sessionStorage value, removing.', key, error);
    sessionStorage.removeItem(key.toString());
  }
  return defaultValue || null;
}

function del(key) {
  sessionStorage.removeItem(key.toString());
}

export default {
  set,
  get,
  del,
};
